import React from "react";
import { Lightbulb } from "lucide-react";
import type { GeneratedSlides, ColorScheme } from "../types";
import { getSlideColor, getSlideBgColor } from "../utils";

interface TipsSectionProps {
  generatedSlides: GeneratedSlides;
  colorScheme: ColorScheme;
}

export const TipsSection: React.FC<TipsSectionProps> = ({
  generatedSlides,
  colorScheme,
}) => {
  const primaryColor = getSlideColor(colorScheme);
  const bgColor = getSlideBgColor(colorScheme);

  if (!generatedSlides?.presentationTips?.length) return null;

  return (
    <div>
      <h4 className="font-bold mb-3 flex items-center gap-2 text-(--text-primary)">
        <Lightbulb className="w-5 h-5" />
        Dicas de Apresentação
      </h4>
      <div className="space-y-2">
        {generatedSlides.presentationTips.map((tip, index) => (
          <div
            key={index}
            className="flex items-center gap-3 p-3 rounded-lg border border-(--border-color) bg-(--bg-accent)"
          >
            <div
              className="w-6 h-6 rounded-full flex items-center justify-center shrink-0"
              style={{ backgroundColor: bgColor }}
            >
              <span
                className="text-xs font-medium"
                style={{ color: primaryColor }}
              >
                {index + 1}
              </span>
            </div>
            <span className="text-(--text-secondary)">{tip}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
